export default {fields:{plateSchemas:{spreads:{PlateSchema:{}}}},typenameResolver:'QueryTypenameResolver'}